import { PaginationConfigProps } from './types';

export function getPageAssets(assets: any[], paginationConfig: PaginationConfigProps, assetsPerPage: number) {
  return assets.slice((paginationConfig.current - 1) * assetsPerPage, paginationConfig.current * assetsPerPage);
}
